import { render } from "./PreviewPDF.vue?vue&type=template&id=30ca140b"
import script from "./PreviewPDF.vue?vue&type=script&lang=js"
export * from "./PreviewPDF.vue?vue&type=script&lang=js"

import "./PreviewPDF.vue?vue&type=style&index=0&id=30ca140b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__